import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FeaturedPostgraduate, FeaturedUndergraduate } from '@uc/web/shared/data-models';
import { CourseOption } from '../../models/course.models';
import { NgClass, NgIf } from '@angular/common';
import { TransformStringPipe } from '@uc/utilities';
import { ArrowDownSvgComponent } from '@uc/shared/svg';
import { CourseInformationTableRowComponent } from '../course-information-table-row/course-information-table-row.component';

@Component({
	selector: 'uc-course-information',
	templateUrl: './course-information.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		NgClass,
		NgIf,
		TransformStringPipe,
		ArrowDownSvgComponent,
		CourseInformationTableRowComponent,
	],
})
export class CourseInformationComponent {
	courseOptions = input.required<CourseOption[]>();
	selectedIndex = input.required<number>();
	isFeatured = input.required<FeaturedUndergraduate | FeaturedPostgraduate>();
	clearingCourseEnabled = input.required<boolean>();

	selectIndex = output<number>();

	onSelectedCourseOption(event: Event) {
		const value = (event.target as HTMLSelectElement).value;
		this.selectIndex.emit(+value);
	}

	formatAddress(address: string) {
		return address.substring(0, address.lastIndexOf(','));
	}
}
